import React from 'react';
import { ArrowRight, Briefcase } from 'lucide-react';

const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="min-h-screen flex items-center justify-center px-6 pt-24">
      <div className="max-w-6xl mx-auto text-center">
        <div className="space-y-8 fade-in-section">
          <div className="inline-block px-4 py-2 border border-gold/30 text-gold text-sm tracking-widest mb-4">
            PHOTOGRAPHER · VIDEOGRAPHER · CREATIVE DIRECTOR
          </div>
          
          <h1 className="font-playfair text-5xl md:text-7xl lg:text-8xl font-bold leading-tight">
            Visual Storytelling<br />
            <span className="text-gold">for Modern Brands</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-300 max-w-4xl mx-auto leading-relaxed">
            I create photography, video, and visual content that helps brands tell their story, 
            define their identity, and connect with their audience.
          </p>
          
          <p className="text-lg text-gray-400 max-w-3xl mx-auto">
            From hands-on production to full creative direction, I take projects from concept 
            through execution — working independently or leading a trusted team of creatives 
            when the scope calls for it.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-8">
            <button 
              onClick={() => scrollToSection('work')}
              className="group px-8 py-4 bg-magenta hover:bg-magenta/90 text-white transition-all duration-300 flex items-center gap-2 text-lg font-medium"
            >
              View Work
              <ArrowRight className="group-hover:translate-x-1 transition-transform" size={20} />
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="px-8 py-4 border border-white hover:border-gold hover:text-gold transition-all duration-300 text-lg font-medium"
            >
              Contact
            </button>
          </div>
          
          <div className="pt-12 flex items-center justify-center gap-2 text-sm text-gold">
            <Briefcase size={16} />
            <span>Experience across hospitality, lifestyle, and service-based brands</span>
          </div>
        </div>
        
        <div className="mt-20 border-t border-gold/20"></div>
      </div>
    </section>
  );
};

export default Hero;